module.exports = __webpack_public_path__ + "static/media/sn-nicolas_preview.f5240872.png";